import React from 'react';
import GridContainer from '../../../@jumbo/components/GridContainer';
import PageContainer from '../../../@jumbo/components/PageComponents/layouts/PageContainer';
import IntlMessages from '../../../@jumbo/utils/IntlMessages';

import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';
import MediaContainer from '@jumbo/Dashboards/Media';

const breadcrumbs = [
  { label: <IntlMessages id={'sidebar.main'} />, link: '/' },
  { label: <IntlMessages id={'pages.mediaPage'} />, isActive: true },
];

const Media = () => {
  return (
    <PageContainer heading={<IntlMessages id="pages.mediaPage" />} breadcrumbs={breadcrumbs}>
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.mediaPage.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <MediaContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default Media;
